module.exports = __webpack_public_path__ + "img/fashion_thumbnail.cfc5a460.jpg";